import { ChevronDownIcon } from "@fluentui/react-icons-mdl2";
import { Button, Menu, Space } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setIncompleteProfile, toggleLoginModal } from "../../../modules/login/redux/LoginSlice";
import { useLazyCheckCompleteProfileQuery } from '../../../redux/api/AccountApi'
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks";
import { ReactComponent as Bars } from '../../../assets/images/bars-solid.svg';
import Logo from '../../../assets/images/IconAmber.svg';
// import IconViettel from '../../../assets/images/IconViettel.png';

const { SubMenu } = Menu;

const HeaderMenu = () => {
    const [trigger, response] = useLazyCheckCompleteProfileQuery()
    const [isBreakpoint, setIsBreakpoint] = useState(false);
    const navigate = useNavigate();
    const userState = useAppSelector(state => state.login);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const setBreakpoint = (breakpoint: number) => {
            if (breakpoint <= 1000) {
                setIsBreakpoint(true);
            } else {
                setIsBreakpoint(false);
            }
        }

        setBreakpoint(window.innerWidth);

        window.addEventListener("resize", () => {
            setBreakpoint(window.innerWidth)
        })
    }, [])

    useEffect(() => {
        if (userState.user.userId) {
            trigger({}).unwrap().then(res => {
                if (res) {
                    dispatch(setIncompleteProfile(false))
                } else {
                    dispatch(setIncompleteProfile(true));
                }
            }).catch(err => {
                dispatch(setIncompleteProfile(true));
            })
        }
    }, [dispatch, trigger, userState.user.userId])

    const checkCompleteProfile = () => {
        if (!userState.user.userId) {
            dispatch(toggleLoginModal());
        } else {
            if (response.data)
                navigate("/auction-register")
            else
                navigate("/profile/detail/redirect", { state: '/auction-register' })
        }
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <div
                className='responsive-padding-1440'
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: isBreakpoint ? 'column' : 'row',
                    padding: '30px 0px'
                }}>
                {/* <img src={Logo} alt="logo" style={{ height: 85 }} /> */}
                <Space>
                    <div>
                        {/* <span style={{ color: "rgba(182, 124, 11, 1)", fontSize: 18 }}>Logo</span> */}
                        {/* <IconAmber /> */}
                        <img src={Logo} alt="logo" style={{ height: 85 }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="font-size-24"><span className="font-bold">ĐẤU GIÁ TRỰC TUYẾN</span></div>
                        <span style={{ color: '#322D1F' }}>TRUNG TÂM DỊCH VỤ ĐẤU GIÁ TÀI SẢN TP.HỒ CHÍ MINH</span>
                    </div>
                </Space>
                <Menu
                    mode="horizontal"
                    className="header-menu" style={{ fontWeight: 700, color: "#222", minWidth: 0, flex: "auto" }}
                    overflowedIndicator={<Bars style={{ width: 20, height: 20 }} />}>
                    <Menu.Item key="home">
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="intro">
                        <Link to="/intro">Giới thiệu</Link>
                    </Menu.Item>
                    <SubMenu
                        key="info"
                        icon={<ChevronDownIcon />}
                        title="Thông tin đấu giá"
                        popupClassName="header-submenu-popup"
                        className="header-submenu">
                        <Menu.Item key="upcoming">
                            <Link to="/auction-list/upcoming">Sắp diễn ra</Link>
                        </Menu.Item>
                        <Menu.Item key="ongoing">
                            <Link to="/auction-list/ongoing">
                                Đang diễn ra
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="end">
                            <Link to="/auction-list/finish">
                                Đã kết thúc
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <Menu.Item key="info-other">
                        <Link to="/auction-list-other">Đấu giá khác</Link>
                    </Menu.Item>
                    <Menu.Item key="event">
                        <Link to="/event">Tin tức</Link>
                    </Menu.Item>
                    <SubMenu
                        key="support"
                        icon={<ChevronDownIcon />}
                        title="Hỗ trợ"
                        popupClassName="header-submenu-popup"
                        className="header-submenu">
                        <Menu.Item key="procedure">
                            <Link to="/procedure">Hướng dẫn thủ tục</Link>
                        </Menu.Item>
                        <Menu.Item key="contact">
                            <Link to="/contact-us">Liên hệ</Link>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
                <Button
                    className="button-light-yellow font-size-16"
                    style={{ height: 50 }}
                    onClick={() => checkCompleteProfile()}>
                    {/* <Link to='/auction-register'> */}
                    ĐĂNG KÝ BÁN ĐẤU GIÁ
                    {/* </Link> */}
                </Button>
            </div >
        </div >
    )
}

export default HeaderMenu;